import React from 'react';
const stats = ['+3 años experiencia', '+$20K usd este 2026', '+500 marcas', '+3.597 alumnas'];
export function MentorSection() {
  return <section className="px-6 py-12 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-125">
      <h2 className="font-serif text-3xl md:text-5xl text-brand-navy mb-8" data-id="element-126">
        ¿Por qué YO te puedo enseñar?
      </h2>

      <div className="w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-12 items-center mx-auto px-4" data-id="element-127">
        <div className="flex flex-col items-center" data-id="element-128">
          {/* Circular Mentor Image */}
          <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-white shadow-xl mb-6" data-id="element-129">
            <img src="https://cdn.magicpatterns.com/uploads/i85boBmhYGDomz8PZSyPbd/pasted-image.png" alt="Brenda Hormaechea" className="w-full h-full object-cover" data-id="element-130" />
          </div>

          <h3 className="font-serif text-2xl md:text-3xl font-bold text-brand-navy mb-1" data-id="element-131">
            Brenda Hormaechea
          </h3>
          <p className="font-serif italic text-brand-navy text-sm md:text-base mb-8 leading-tight max-w-[280px] md:max-w-md" data-id="element-132">
            <strong className="font-bold" data-id="element-133">@entualma.viajes</strong> Creadora Ugc
            ✨ Embajadora de marcas y Travel Influencer
          </p>
        </div>

        <div className="flex flex-col items-center md:items-start" data-id="element-134">
          {/* Stats Grid */}
          <div className="grid grid-cols-2 gap-3 w-full mb-10" data-id="element-135">
            {stats.map((stat, i) => <div key={i} className="bg-[#e2f5e9] border border-[#a8d5ba] rounded-2xl p-3 md:p-5 flex items-center gap-2 text-left" data-id="element-136">
                <span className="text-sm md:text-base shrink-0" data-id="element-137">✅</span>
                <span className="font-serif text-brand-navy text-[13px] md:text-base font-bold leading-tight" data-id="element-138">
                  {stat}
                </span>
              </div>)}
          </div>

          <p className="font-serif text-brand-navy text-lg md:text-2xl leading-relaxed max-w-[320px] md:max-w-xl md:text-left" data-id="element-139">
            Te voy a enseñar paso a paso cómo lograr tener{' '}
            <strong className="font-bold" data-id="element-140">
              un portfolio lleno de trabajos UGC
            </strong>{' '}
            💘
          </p>
        </div>
      </div>
    </section>;
}